// Shared "world mode" state — Classic (numbers/rings) ⇄ Living (visual avatar).
// The dashboard toggle sets it; the bottom nav (and anything else) reacts live.
// Persisted in localStorage so the choice survives navigation + reloads.
import { useEffect, useState } from 'react';

export const WORLD_MODE_KEY = 'revivo_world_mode';
const EVENT = 'worldmode:change';

// Default to the Living "Journey" visual experience (the product's flagship
// layer). A user who explicitly switches to Insights has 'classic' persisted and
// is respected on return; only a fresh/unset state falls back to Journey.
export const getWorldMode = () => localStorage.getItem(WORLD_MODE_KEY) || 'living';

export const setWorldMode = (mode) => {
  localStorage.setItem(WORLD_MODE_KEY, mode);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: mode }));
};

// Live hook — re-renders any component when the mode flips (this tab or another).
export const useWorldMode = () => {
  const [mode, setMode] = useState(getWorldMode);
  useEffect(() => {
    const sync = () => setMode(getWorldMode());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync); // cross-tab
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return mode;
};
